// source: http://stackoverflow.com/a/8809472/2665105
/* eslint-disable no-bitwise */

export const uuid = () => {
  let d = new Date().getTime()
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16)
  })
}

export const baseUuid = (prefix: string = '') => {
  if (prefix.length > 8) {
    throw new Error(`Custom prefix can only have a maximum of 8 characters`)
  }
  return `${prefix}${uuid().slice(prefix.length)}`
}

// legacy object, import functions directly:
const UUID = {uuid}

export default UUID
